import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#21808D', // Updated to match Shree Balaji colors
      light: '#32B8C6',
      dark: '#1A6B78',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FFC107',
      light: '#FFD54F',
      dark: '#FF8F00',
      contrastText: '#000000',
    },
    background: {
      default: '#FCFCF9',
      paper: '#FFFFFE',
    },
    text: {
      primary: '#13343B',
      secondary: '#626C71',
    },
    text2: {
      primary: '#626C71',
    },
    background2: {
      paper: '#1A2A5F',
    },
  },
  typography: {
    fontFamily: [
      'FKGroteskNeue',
      'Geist',
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      color: '#13343B',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: '#13343B',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: '#13343B',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: '#13343B',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: '#13343B',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      color: '#FFC107',
    },
    body1: {
      fontSize: '1rem',
      color: '#13343B',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      color: '#E0E0E0',
      lineHeight: 1.6,
    },
    brandTitle: {
      fontFamily: "'Goodland Condensed Bold', sans-serif",
      fontSize: "1.1rem",
      fontWeight: 600,
      // letterSpacing: "0.15em",
      textTransform: "uppercase",
      color: "#1A2A5F",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontSize: '1rem',
          fontWeight: 500,
          padding: '8px 16px',
        },
        containedPrimary: {
          backgroundColor: '#21808D',
          '&:hover': {
            backgroundColor: '#1D7480',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02)',
          border: '1px solid rgba(94, 82, 64, 0.12)',
          '&:hover': {
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.04), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
          },
        },
      },
    },
  },
});

export default theme;
